import normalizeUrl from 'normalize-url';
export const normalizeDomain = (domain) => {
    const { hostname } = new URL(normalizeUrl(domain, { stripWWW: true }));
    return hostname;
};
